(function () {
  const setLang = (lang) => {
    const code = lang === "sq" ? "sq" : "en";
    document.documentElement.lang = code;
    document.querySelectorAll("[data-en]").forEach((el) => {
      const value = el.getAttribute("data-" + code);
      if (value !== null) el.textContent = value;
    });
    document.querySelectorAll("[data-en-ph]").forEach((el) => {
      const value = el.getAttribute("data-" + code + "-ph");
      if (value !== null) el.placeholder = value;
    });
    document.querySelectorAll(".ela-lang button").forEach((button) => {
      button.setAttribute("aria-pressed", button.dataset.lang === code ? "true" : "false");
    });
    try {
      localStorage.setItem("mrsela-lang", code);
    } catch (e) {}
  };

  document.querySelectorAll(".ela-lang button").forEach((button) => {
    button.addEventListener("click", () => setLang(button.dataset.lang));
  });

  try {
    const saved = localStorage.getItem("mrsela-lang");
    if (saved) setLang(saved);
  } catch (e) {}

  const drawer = document.getElementById("ela-drawer");
  const scrim = document.getElementById("ela-scrim");
  const burger = document.getElementById("ela-burger");
  const closeBtn = document.getElementById("ela-drawer-close");

  const openDrawer = () => {
    if (!drawer || !scrim) return;
    drawer.classList.add("is-open");
    scrim.classList.add("is-on");
    drawer.setAttribute("aria-hidden", "false");
    document.body.style.overflow = "hidden";
  };
  const closeDrawer = () => {
    if (!drawer || !scrim) return;
    drawer.classList.remove("is-open");
    scrim.classList.remove("is-on");
    drawer.setAttribute("aria-hidden", "true");
    document.body.style.overflow = "";
  };

  burger?.addEventListener("click", openDrawer);
  closeBtn?.addEventListener("click", closeDrawer);
  scrim?.addEventListener("click", closeDrawer);
  drawer?.querySelectorAll("a").forEach((link) => link.addEventListener("click", closeDrawer));
  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape") closeDrawer();
  });

  const header = document.querySelector(".ela-header");
  const mobileCta = document.getElementById("ela-mobile-cta");
  const onScroll = () => {
    header?.classList.toggle("is-stuck", window.scrollY > 8);
    mobileCta?.classList.toggle("is-show", window.scrollY > 620);
  };
  window.addEventListener("scroll", onScroll, { passive: true });
  onScroll();

  document.querySelectorAll(".ela-chip").forEach((chip) => {
    chip.addEventListener("click", () => {
      const group = chip.closest(".ela-watch");
      group?.querySelectorAll(".ela-chip").forEach((item) => item.classList.remove("is-on"));
      chip.classList.add("is-on");
      const cat = chip.dataset.cat;
      group?.querySelectorAll(".ela-vid").forEach((video) => {
        video.hidden = cat !== "all" && video.dataset.cat !== cat;
      });
    });
  });
})();
